import { seo } from 'components/lexemes';
import { FeatureRoutes } from 'lib/features';

import { RouteName } from 'containers/routes';

type Route = RouteName | FeatureRoutes;

type MapRouteToSeoTitleRecord = { [key in Route]: string };

// @TODO - change to lexemes
export enum SeoTitle {
  index = 'Bumble | Date, Chat & Meet New People',
  about = 'About - Bumble | Date, Chat & Meet New People',
  date = 'Date - Bumble | Date, Chat, Meet New People',
  bffUS = 'BFF - Find New Friends With Bumble For Friends App',
}

export const seoTitleFabric: (pathname: Route) => string = (pathname) => {
  const seoTitle: MapRouteToSeoTitleRecord = {
    [RouteName.index]: SeoTitle.index,
    [RouteName.about]: SeoTitle.about,
    [RouteName.date]: SeoTitle.date,
    [RouteName.bffUS]: SeoTitle.bffUS,
    [RouteName.localisedIndex]: SeoTitle.index,
    [RouteName.localisedAbout]: SeoTitle.about,
    [RouteName.localisedDate]: SeoTitle.date,
    [RouteName.localisedBffUS]: SeoTitle.bffUS,
    [FeatureRoutes.Compliments]: seo.lxFeatureComplimentsSEOTitle,
    [FeatureRoutes.Incognito_mode]: seo.lxFeatureIncognitoModeSEOTitle,
    [FeatureRoutes.Snooze_mode]: seo.lxFeatureSnoozeModeSEOTitle,
    [FeatureRoutes.Superswipe]: seo.lxFeatureSuperswipeSEOTitle,
    [FeatureRoutes.Travel_mode]: seo.lxFeatureTravelModeSEOTitle,
    [FeatureRoutes.Video_chat]: seo.lxFeatureVideoChatSEOTitle,
    [FeatureRoutes.Instant_match]: seo.lxFeatureInstantMatchSEOTitle,
    [FeatureRoutes.Discover]: seo.lxFeatureDiscoverSEOTitle,
    [FeatureRoutes.LocalisedCompliments]: seo.lxFeatureComplimentsSEOTitle,
    [FeatureRoutes.LocalisedIncognito_mode]: seo.lxFeatureIncognitoModeSEOTitle,
    [FeatureRoutes.LocalisedSnooze_mode]: seo.lxFeatureSnoozeModeSEOTitle,
    [FeatureRoutes.LocalisedSuperswipe]: seo.lxFeatureSuperswipeSEOTitle,
    [FeatureRoutes.LocalisedTravel_mode]: seo.lxFeatureTravelModeSEOTitle,
    [FeatureRoutes.LocalisedVideo_chat]: seo.lxFeatureVideoChatSEOTitle,
    [FeatureRoutes.LocalisedInstantMatch]: seo.lxFeatureInstantMatchSEOTitle,
    [FeatureRoutes.LocalisedDiscover]: seo.lxFeatureDiscoverSEOTitle,
  };

  return seoTitle[pathname as Route];
};

export const setSeoTitle = (pathname: Route) => {
  return seoTitleFabric(pathname as Route);
};
